import { prepareSquareBanner } from '~/src/features/internetV2/helpers/transformer';

export const features = [
    {
        title: <>Убедитесь в&nbsp;качестве</>,
        description: <>Замерьте скорость и&nbsp;проведите диагностику&nbsp;&mdash; убедитесь, насколько быстрый наш интернет</>,
    },
    {
        title: <>Не&nbsp;вставайте с&nbsp;дивана</>,
        description: <>Управляйте роутером и&nbsp;домашним Wi-Fi прямо в&nbsp;приложении</>,
    },
    {
        title: 'Управляйте услугами',
        description: <>Подключайте новые, отключайте старые, ставьте услуги на&nbsp;паузу на&nbsp;время отъезда. И&nbsp;управляйте заявками на&nbsp;подключение.</>,
    },
    {
        title: 'Тут всё для вас',
        description: <>Настраивайте приложение под себя и&nbsp;получайте персональные предложения</>,
    },
].map(prepareSquareBanner({ section: 'app', category: 'features' }));

export const subscriptions = [
    {
        title: 'Все сервисы Яндекса',
        description: <>Настраивайте приложение под себя и&nbsp;получайте персональные предложения</>,
    },
    {
        title: 'Игры без границ',
        description: <>Получайте 2&nbsp;игры в&nbsp;подарок каждый месяц и&nbsp;пользуйтесь облачным геймингом</>,
    },
    {
        title: 'Много-много кино',
        description: <>Смотрите эксклюзивные фильмы и&nbsp;сериалы в&nbsp;любимых онлайн-кинотеатрах</>,
    },
    {
        title: 'Полезные сервисы',
        description: <>Для присмотра за&nbsp;детьми, чтения книг, хранения файлов и&nbsp;многого другого</>,
    },
].map(prepareSquareBanner({ section: 'entertainment', category: 'subscriptions' }));
